import { render, staticRenderFns } from "./CellCreateOrUpdate.vue?vue&type=template&id=1271d139"
import script from "./CellCreateOrUpdate.vue?vue&type=script&lang=js"
export * from "./CellCreateOrUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports